import angular from 'angular';
import { changePageTitle } from 'auth/actions/session.actions';

export default angular.module('terms-management-routing', []).config([
  '$stateProvider',
  function configure($stateProvider) {
    $stateProvider.state('cms-termsOfUseManagement', {
      parent: 'arw',
      url: '/cms-terms-of-use-management',
      template: '<cms-terms-of-use-management />',
      redirectTo: 'permissions-denied',
      params: {
        pageTitle: [
          '$ngRedux',
          'gettextCatalog',
          ($ngRedux, gettextCatalog) => {
            $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Manage Legal Policies')));
          },
        ],
      },
    });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/terms/terms-management-routing-module.js